<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-input v-model="getUserPhoneModelList_data.yupmBrand" placeholder="请输入手机品牌" clearable size='small'
                    style="max-width:150px;" />
                <el-input v-model="getUserPhoneModelList_data.yupmModel" placeholder="请输入型号" clearable size='small'
                    style="max-width:150px;" />
                <el-input v-model="getUserPhoneModelList_data.yupmPlatform" placeholder="请输入平台" clearable size='small'
                    style="max-width:150px;" />
                <el-select v-model="getUserPhoneModelList_data.yupmStatusMedia" v-change.getUserPhoneModelList
                    size="small" style="width: 80px;" filterable clearable placeholder="请选择媒体类型">
                    <el-option label="视频" :value="1"></el-option>
                    <el-option label="音频" :value="2"></el-option>
                </el-select>
                <el-button v-click.getUserPhoneModelList type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if='addUserPhoneModel' @click=" $form('addUserPhoneModel')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加拜访类型
                </el-button>
                <el-button v-if='addUserPhoneModel' @click="getUserMobilePhone" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>获取所有用户
                </el-button>
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getUserPhoneModelList' api='getUserPhoneModelList'
            updateapi='updateUserPhoneModel' :height="H - 165">
        </mytable>

        <myform :viewobj='{
                addUserPhoneModel: ["新增手机型号", "el-icon-circle-plus"],
                updateUserPhoneModel: ["修改手机型号", "el-icon-edit-outline"],
                $succeed$: getUserPhoneModelList
            }' @close='$form("addUserPhoneModel", "reset")'>
            <!-- <hide slot='vtId' /> -->
        </myform>
        <myform view.getUserPhoneModelUserMoreTwo='详情'>
            <mytable :tableColums='tableColums_getUserPhoneModelUserMore' api='getUserPhoneModelUserMoreTwo::yupmId'
                updateapi='updateUserPhoneModelUserMore' :height="H - 165">
            </mytable>
            <myform view.updateUserPhoneModelUserMore='编辑用户手机型号'>

            </myform>

            <hide slot='yupmStatusMedia' />
            <hide slot='projectId' />
            <hide slot='userName' />
            <hide slot='userPhone' />
            <hide slot='yupmBrand' />
            <hide slot='yupmId' />
            <hide slot='currentPage' />
            <hide slot='pageSize' />
        </myform>
        <myform view.getUserPhoneModelUserMoreUser='详情' width="80%">
            <el-row style="margin-bottom:10px;">
                <el-col :span="18" class='flex'>
                    <el-select v-model='theProjectId' @change="theProjectAllChange" size="small" clearable
                        placeholder="请选择项目">
                        <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                            :label="item.projectName" :value="item.projectId">
                        </el-option>
                    </el-select>
                    <el-input v-model="getUserPhoneModelUserMore_data.userName" placeholder="请输入用户名" clearable
                        size='small' style="max-width:150px;" />
                    <el-input v-model="getUserPhoneModelUserMore_data.userPhone" placeholder="请输入手机型号" clearable
                        size='small' style="max-width:150px;" />
                    <el-input v-model="getUserPhoneModelUserMore_data.yupmBrand" placeholder="请输入品牌" clearable
                        size='small' style="max-width:150px;" />
                    <el-select v-model="getUserPhoneModelUserMore_data.yupmStatusMedia"
                        v-change.getUserPhoneModelUserMore size="small" style="width: 150px;" filterable clearable
                        placeholder="请选择媒体类型">
                        <el-option label="视频" :value="1"></el-option>
                        <el-option label="音频" :value="2"></el-option>
                    </el-select>
                    <!-- <el-input v-model="getUserPhoneModelUserMore_data.yupmPlatform" placeholder="请输入平台" clearable size='small'
                    style="max-width:150px;" /> -->
                    <el-button v-click.getUserPhoneModelUserMore type="primary" icon='el-icon-search' size='small'
                        style='margin-left:10px;'>搜索
                    </el-button>
                </el-col>
            </el-row>

            <mytable :tableColums='tableColums_getUserPhoneModelUserMore' api='getUserPhoneModelUserMore'
                updateapi='updateUserPhoneModelUserMore' :height="H - 165">
            </mytable>
            <myform view.updateUserPhoneModelUserMore='编辑用户手机型号'>

            </myform>
            <hide slot='yupmStatusMedia' />
            <hide slot='yupmId' />
            <hide slot='currentPage' />
            <hide slot='pageSize' />
        </myform>
    </div>
</template>

<script>
export default {
    data() {
        return {
            vtId: null,
            theProjectId: "",
            theUserProject: "",
            tableColums_getUserPhoneModelList: {
                $selection: false,

                yupmBrand: '品牌',

                yupmModel: '设备型号',

                yupmPlatform: '客户端平台',
                yupmSystem: '操作系统及版本',
                yupmMemorySize: '设备内存大小',

                yupmStatusCompress: ['是否压缩', , '@v-if: 1:是 #(--Themecolor),  2:否 #warn'],
                yupmStatusMedia: ['媒体类型', , '@v-if: 1:视频 #(--Themecolor),  2:音频 #warn'],

                $operation: [
                    '操作', 200,
                    this.updateUserPhoneModel && `@text: 编辑#success
             @click: $form("updateUserPhoneModel",$row)
            `,
                    this.getUserPhoneModelUserMore && `@text: 详情#success
           @click: $form("getUserPhoneModelUserMoreTwo",$this.row = $row),getUserPhoneModelUserMoreTwo({yupmId:$row.yupmId})
          `,
                ],

            },
            tableColums_getUserPhoneModelUserMore: {
                $selection: false,

                userName: '用户',

                userPhone: '用户手机号',
                yupmBrand: '品牌',
                yupmModel: '设备型号',

                yupmPlatform: '客户端平台',
                yupmSystem: '手机版本',
                yupmMemorySize: '内存大小',
                yupmStatusCompress: '视频是否压缩(1:是,2:否)',
                yupmStatusMedia: '媒体类型(1:视频,2:音频)',

                // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],

                $operation: [
                    '操作', 200,
                    this.updateUserPhoneModelUserMore && `@text: 编辑#success
             @click: $form("updateUserPhoneModelUserMore",$row)
            `,
                ],

            },
        };
    },

    watch: {

    },
    methods: {
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getUserPhoneModelUserMore({ projectId: this.theProjectId });
        },
        getUserMobilePhone() {
            this.getUserPhoneModelUserMore()
            this.$form("getUserPhoneModelUserMoreUser");
        }
    },

    created() {
        this.theUserProject = A.local('$projectId');
        if (this.theUserProject == 0) {
            this.getProjectList({ pageSize: 0 });
        } else {
            this.theProjectId = this.theUserProject;
            this.getDepartmentAllList();
        }
        this.getUserPhoneModelList();
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/bussiness/MobilePhone.vue